// Mock data for PixZent Landing Page

export const stats = [
  { value: '847%', label: 'Average ROI Increase' },
  { value: '1T+', label: 'AI Queries Optimized' },
  { value: '94%', label: 'Client Retention Rate' },
  { value: '48hrs', label: 'Audit Delivery Time' }
];

export const trustedCompanies = [
  'TechFlow Solutions', 'Prestige Properties', 'Elite Dental Group',
  'Global Logistics Co', 'Summit Law Firms', 'Oasis Hospitality',
  'Prime Finance Group', 'InnovateTech Labs', 'Luxury Motors UAE',
  'HealthCare Plus', 'EduSmart Academy', 'BuildRight Construction'
];

export const features = [
  {
    icon: 'Search',
    title: 'AI Search Optimization (AEO)',
    description: 'Get your brand recommended by ChatGPT, Perplexity, and Grok when users ask for solutions in your industry.',
    points: ['AI citation building', 'Entity optimization', 'Conversational keyword targeting']
  },
  {
    icon: 'Sparkles',
    title: 'Generative Engine Optimization (GEO)',
    description: 'Optimize for AI-generated responses across search engines and ensure your brand appears in synthesized answers.',
    points: ['Schema markup optimization', 'Knowledge graph enhancement', 'AI response tracking']
  },
  {
    icon: 'TrendingUp',
    title: 'Traditional SEO Excellence',
    description: 'Dominate Google search results with proven strategies that drive consistent organic traffic and conversions.',
    points: ['Technical SEO audit', 'Content optimization', 'Backlink strategy']
  },
  {
    icon: 'MapPin',
    title: 'Local SEO & GMB',
    description: 'Own your local market with optimized Google Business profiles and local search visibility.',
    points: ['GMB optimization', 'Local citation building', 'Review management']
  }
];

export const processSteps = [
  {
    step: '01',
    title: 'AI Visibility Audit',
    duration: '48 Hours',
    description: 'We analyze how your brand appears across AI platforms and identify optimization opportunities.'
  },
  {
    step: '02',
    title: 'Strategy Development',
    duration: '1 Week',
    description: 'Custom roadmap combining AEO, GEO, SEO, and paid strategies tailored to your industry.'
  },
  {
    step: '03',
    title: 'Implementation',
    duration: 'Ongoing',
    description: 'Execute optimizations across all channels with continuous monitoring and refinement.'
  },
  {
    step: '04',
    title: 'Growth & Scale',
    duration: 'Continuous',
    description: 'Track results, scale what works, and continuously expand your digital dominance.'
  }
];

export const testimonials = [
  {
    metric: '+340%',
    metricLabel: 'Patient Inquiries',
    quote: 'Within 3 months, we went from invisible to being the #1 recommended dental clinic in our region on ChatGPT. Our patient inquiries increased by 340%.',
    name: 'Dr. Ahmed Hassan',
    role: 'Founder, Dental Excellence'
  },
  {
    metric: '+520%',
    metricLabel: 'Qualified Leads',
    quote: "PixZent's AI-first approach transformed our digital presence. We're now featured in AI responses for luxury real estate queries across our market.",
    name: 'Sarah Al Maktoum',
    role: 'CEO, Gold Premium Properties'
  },
  {
    metric: '+890%',
    metricLabel: 'Organic Traffic',
    quote: 'The combination of AEO and traditional SEO gave us a competitive edge no one else in our industry has. Game-changing results.',
    name: 'Rajesh Sharma',
    role: 'Marketing Director, TechWise Solutions'
  }
];

export const industries = [
  'Dental Clinics', 'Real Estate', 'Logistics', 'Law Firms',
  'Hospitality', 'Finance', 'Manufacturing', 'Education',
  'Automotive', 'Luxury Retail', 'E-commerce', 'Health & Wellness',
  'Technology', 'Construction', 'Other'
];

export const faqs = [
  {
    question: 'What is Answer Engine Optimization (AEO)?',
    answer: 'AEO is the practice of optimizing your digital presence to appear in AI-generated answers. When users ask ChatGPT, Perplexity, or Grok for recommendations, AEO ensures your brand is featured prominently in those responses.'
  },
  {
    question: 'How is AEO different from traditional SEO?',
    answer: 'While traditional SEO focuses on ranking in search engine results pages, AEO targets AI-powered answer engines. It involves optimizing for conversational queries, building entity authority, and ensuring your brand data is accurately represented across AI training sources.'
  },
  {
    question: 'How long does it take to see results?',
    answer: 'Most clients see initial improvements within 4-6 weeks, with significant results typically appearing within 2-3 months. Our 48-hour audit gives you immediate insights, and we provide monthly progress reports to track your AI visibility growth.'
  },
  {
    question: 'Do you provide reporting and analytics?',
    answer: 'Yes! We provide comprehensive monthly reports showing your AI visibility scores, citation tracking, competitor analysis, and actionable recommendations. You\'ll have full visibility into how your brand performs across all major AI platforms.'
  },
  {
    question: 'What industries do you specialize in?',
    answer: 'We work across all industries including dental clinics, real estate, law firms, healthcare, hospitality, technology, e-commerce, and more. Our strategies are customized for each industry\'s unique competitive landscape.'
  },
  {
    question: 'Is there a long-term contract required?',
    answer: 'No long-term contracts required. We offer flexible month-to-month plans because we\'re confident in our results. Our 94% client retention rate speaks to the value we deliver.'
  },
  {
    question: 'What\'s included in the free audit?',
    answer: 'Our free 48-hour audit includes: AI visibility analysis across ChatGPT, Perplexity & Grok; competitor benchmarking; content gap analysis; and a custom optimization roadmap with actionable recommendations.'
  }
];

export const chatbotResponses = {
  'What services does PixZent offer?': 'PixZent offers comprehensive AI visibility services including: AI Search Optimization (AEO), Generative Engine Optimization (GEO), Traditional SEO Excellence, Local SEO & GMB optimization, and High-Converting Landing Page Design. We help brands get discovered by ChatGPT, Perplexity, Grok, and traditional search engines.',
  'How much does it cost?': 'Our pricing is customized based on your specific needs and goals. We offer flexible packages starting from our entry-level AI Visibility Starter plan. Book a free strategy call to get a personalized quote tailored to your business.',
  'How do I get started?': 'Getting started is easy! You can either: 1) Fill out our Free Audit Form to receive a comprehensive 48-hour AI visibility analysis, or 2) Book a Strategy Call directly to discuss your goals with our experts. Both options are completely free with no obligation.',
  'What is AI Visibility?': 'AI Visibility refers to how well your brand appears in AI-powered search results and recommendations. When users ask ChatGPT, Perplexity, or Grok for recommendations, AI-visible brands are featured prominently. Our services ensure your brand becomes the answer when potential customers search.',
  'How long does it take to see results?': 'Most clients see initial improvements within 4-6 weeks, with significant results typically appearing within 2-3 months. Our 48-hour audit gives you immediate actionable insights, and we provide regular progress reports to track your growth.',
  'Do you work with international clients?': 'Yes! PixZent works with clients globally. We have experience optimizing brands in the UAE, GCC region, North America, Europe, and Asia. Our strategies are adapted to local markets while maintaining global AI visibility best practices.',
  'What industries do you specialize in?': 'We work across diverse industries including dental clinics, real estate, law firms, healthcare, hospitality, technology, e-commerce, finance, education, and more. Our strategies are customized for each industry\'s unique requirements.',
  'default': 'Thank you for your question! For detailed information, please fill out our Free Audit Form or Book a Strategy Call. Our team will be happy to assist you with personalized answers.'
};

export const aiSearchQueries = [
  { category: 'Dental', queries: ['best dental clinic in Dubai', 'top dentist near me', 'best teeth whitening UAE'] },
  { category: 'Real Estate', queries: ['best real estate company Dubai', 'top property agent Marina', 'luxury villa broker'] },
  { category: 'Healthcare', queries: ['best dermatologist Dubai', 'top pediatrician near me', 'best physiotherapy clinic'] },
  { category: 'Legal', queries: ['best corporate lawyer Dubai', 'top immigration attorney', 'best family lawyer'] },
  { category: 'Hospitality', queries: ['best restaurant Downtown Dubai', 'top fine dining Marina', 'best brunch spot JBR'] },
  { category: 'Technology', queries: ['best software company Dubai', 'top app developer UAE', 'best IT consulting firm'] }
];

export const socialLinks = {
  facebook: 'https://www.facebook.com/profile.php?id=61585526124071',
  instagram: 'https://www.instagram.com/pixzent_tech/',
  linkedin: 'https://www.linkedin.com/company/pixzent-technologies'
};

export const contactInfo = {
  email: 'dmb@pixzent.com',
  phone: '+971508541002',
  location: 'Dubai, UAE'
};
